const CareersWideTextAndImage = {
  displayField: 'eyebrow',
  name: 'z-Careers Wide Text and Image',
  description: 'do not use',
  fields: [
    {
      id: 'backgroundColor',
      name: 'Background Color',
      type: 'Boolean',
      localized: false,
      required: false,
      validations: [],
      defaultValue: { 'en-US': true },
      disabled: false,
      omitted: false
    },
    {
      id: 'reverse',
      name: 'Reverse?',
      type: 'Boolean',
      localized: false,
      required: false,
      validations: [],
      defaultValue: { 'en-US': false },
      disabled: false,
      omitted: false
    },
    {
      id: 'imgFocalPoint',
      name: 'ImageFocalPoint',
      type: 'Link',
      localized: false,
      required: false,
      validations: [ { linkContentType: [ 'imageWithFocalPoint' ] } ],
      disabled: false,
      omitted: false,
      linkType: 'Entry'
    },
    {
      id: 'img',
      name: 'Image',
      type: 'Link',
      localized: false,
      required: true,
      validations: [],
      disabled: true,
      omitted: true,
      linkType: 'Asset'
    },
    {
      id: 'eyebrow',
      name: 'Eyebrow',
      type: 'Symbol',
      localized: false,
      required: false,
      validations: [],
      disabled: false,
      omitted: false
    },
    {
      id: 'header',
      name: 'Header',
      type: 'Symbol',
      localized: false,
      required: false,
      validations: [],
      disabled: false,
      omitted: false
    },
    {
      id: 'bodyText',
      name: 'Body Text',
      type: 'Text',
      localized: false,
      required: true,
      validations: [],
      disabled: true,
      omitted: true
    },
    {
      id: 'richText',
      name: 'Rich Text',
      type: 'RichText',
      localized: false,
      required: false,
      validations: [
        {
          enabledMarks: [ 'bold', 'italic' ],
          message: 'Only bold and italic marks are allowed'
        },
        { enabledNodeTypes: [], message: 'Nodes are not allowed' },
        { nodes: {} }
      ],
      disabled: false,
      omitted: false
    },
    {
      id: 'swatch',
      name: 'Swatch',
      type: 'Symbol',
      localized: false,
      required: false,
      validations: [],
      defaultValue: { 'en-US': 'Cream (Default)' },
      disabled: true,
      omitted: true
    },
    {
      id: 'links',
      name: 'Links',
      type: 'Array',
      localized: false,
      required: false,
      validations: [],
      disabled: false,
      omitted: false,
      items: {
        type: 'Link',
        validations: [ { linkContentType: [ 'link', 'linkDownload' ] } ],
        linkType: 'Entry'
      }
    },
    {
      id: 'downloadLink',
      name: 'Download Link',
      type: 'Array',
      localized: false,
      required: false,
      validations: [],
      disabled: true,
      omitted: true,
      items: { type: 'Link', validations: [], linkType: 'Entry' }
    }
  ],
  sys: {
    id: 'CareersWideTextAndImage',
    version: 6,
    updatedAt: '2023-08-02T21:40:01.367Z'
  }
};
export default CareersWideTextAndImage;